import { appConfig } from '../../../../../config/customization';

const fieldStyle = {
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  borderBottomStyle: 'solid',
  borderWidth: 1,
  borderColor: appConfig.colors.fieldDetailSeparatorColor,
  alignItems: 'flex-start',
  justifyContent: 'center',
  paddingTop: 40,
  paddingBottom: 40
};

export default {
  activeRowContent: {
    backgroundColor: appConfig.colors.activeRowColor,
    display: 'flex',
    paddingBottom: 30,
    // TODO: Use Row padding and remove width
    paddingLeft: 60,
    width: 'calc(100% - 60px)',
    boxShadow: 'inset -2px -73px 46px -87px rgba(0,0,0,1)',
    overflow: 'visible',
    height: 258
  },
  fieldContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    maxWidth: '50%',
    overflow: 'auto'
  },
  field: {
    ...fieldStyle
  },
  lastField: {
    ...fieldStyle,
    borderWidth: 0
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1
  },
  button: {
    margin: 20,
    width: 130
  }
};
